import { useState, useEffect } from 'react';

/**
 * Возвращает true только если загрузка длится дольше delay мс.
 * Предотвращает мигание скелетона при быстрых ответах.
 *
 * @param {boolean} loading — реальное состояние загрузки
 * @param {number}  delay   — задержка в мс (по умолчанию 150)
 */
export function useDelayedLoading(loading, delay = 150) {
  const [showSkeleton, setShowSkeleton] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShowSkeleton(false);
      return;
    }

    const timer = setTimeout(() => setShowSkeleton(true), delay);
    return () => clearTimeout(timer);
  }, [loading, delay]);

  return showSkeleton;
}
